import React from 'react'
import { css } from '@emotion/react'
import { colors, fonts } from 'shared-ui'

const style = {
    title: css`
        font-size: 1.5em;
        font-family: ${fonts.special};
        color: ${colors.subtle};
        margin-bottom: 0.5em;
        margin-left: 0.25em;
        line-height: 1.5;
    `,
}

export default function InstructionSteps({ title, ...props }) {
    return (
        <div css={css`line-height: 1.5;`} {...props}>
            <h5 css={style.title}>
                {title}
            </h5>
        </div>
    )
}